/** Emerald/gold glow behind account screens — a stand-in for the live city behind the HUD. */
export function AmbientBackdrop() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute -top-48 left-1/2 size-[720px] -translate-x-1/2 rounded-full bg-primary-container/10 blur-3xl" />
      <div className="absolute -bottom-56 -right-32 size-[520px] rounded-full bg-secondary-container/10 blur-3xl" />
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(var(--color-outline) 1px, transparent 1px), linear-gradient(90deg, var(--color-outline) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
    </div>
  );
}